module.exports = __webpack_public_path__ + "img/1-1.ba2b8cc5.png";